import { useSoyuzData } from '@spotahome/soyuz/client';
import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner
} from '@spotahome/ui-library';

import '@spotahome/landings-common/src/scss/init.scss';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import getSitemapSearchQuery from '@spotahome/landings-common/src/graphql/queries/sitemap-search';

import AllSearchList from './components/AllSearchList';

const AllSearchListContainer = () => {
  const { [AllSearchListContainer.NAME]: requestedData } = useSoyuzData();
  const { sitemapSearch, initialCookie, deviceType, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source="home" deviceType={deviceType} />
          {!userId && <GoogleOneTap />}
          <AllSearchList searchLinkList={sitemapSearch.search} />
          <LazyLoginSignUpModal />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

AllSearchListContainer.requestAllData = async (
  req,
  _,
  { graphqlClient, res }
) => {
  try {
    const locale = req.locale;
    const { data } = await getSitemapSearchQuery(graphqlClient)({ locale });

    if (data.sitemapSearch.search.length === 0) {
      res.redirect('/404');
      return { data: {} };
    }

    return {
      headers: {
        title: 'Spotahome'
      },
      data: {
        ...data,
        deviceType: req.device.type,
        initialCookie: req.headers.cookie,
        userId: req.userId
      }
    };
  } catch (err) {
    req.logger.error('Sitemap search error', { err });
    return {
      data: {
        deviceType: req.device.type,
        initialCookie: req.headers.cookie
      }
    };
  }
};

AllSearchListContainer.NAME = 'AllSearchListContainer';

export default AllSearchListContainer;
